export default __webpack_public_path__ + "static/media/group_3309.b5eb0203.png";